<template>
  <!-- 智慧景区 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{pageData.title}}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">{{pageData.text.text1}}</div>
         &nbsp;
        <div class="img_wrap" v-for="( item, index ) in pageData.imgArr" :key="`${index}-img`">
          <img :src="item.imgUrl" :alt="item.alt" />
        </div>
        &nbsp;
        <div class="article_wrap" v-for="( item, index ) in pageData.text.textArr" :key="index">
          <div class="subtitle">{{item.textTitle}}</div>
          <div class="text unify_article" v-for="( itemText, indexText ) in item.textContent " :key="`${index}-${indexText}`">
            {{itemText}}
          </div>
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageData: {
          title: "智慧景区",
          text: {
            text1: "瑞谦智慧景区解决方案采用先进的物联网、云计算、大数据等技术，通过建立丰富的数字化基础设施和视频监控、人流监控、GIS地图等系统，打造统一管控平台，实现景区实时监测，提升拥堵聚集等事件的响应效率，使景区管理更加规范、科学、智慧，极大提高景区管理效率和景区服务能力。",
            textArr:[
              {
                textTitle: "数据可视化",
                textContent: ["利用物联网技术，景区各种基础设施（门闸、车闸、摄像头、智慧灯杆等）可实时监测、采集景区内的人员和车辆信息，并上传管理平台，通过大屏中心展示客流量，车流量等数据，实现景区数据可视化。"]
              },
              {
                textTitle: "高密区域预警",
                textContent: ["利用大量的视频监控设备，对景区人群、车流密度进行有效地监测与分析，绘制人员、车辆热力图，并及时发出预警信息。"]
              },
              {
                textTitle: "不文明行为识别",
                textContent: ["摄像头抓拍到游客不文明行为，联动信息发布系统，公开通报不文明行为，起到警示作用。"]
              },
              {
                textTitle: "快速安全救援",
                textContent: ["当发生紧急事件时，游客只需扫描或者报告安装在景区的垃圾桶等固定载体上的电子标签码，救援人员即可快速到达现场，实施救援。"]
              },
              {
                textTitle: "景区全景展示",
                textContent:[ "建立景区展示平台，内容包括景点介绍、购票说明、吃住玩购、主题活动、360度全景、景区设施、投诉建议等，优化服务，给游客更好的体验。"]
              }
            ],
          },
          imgArr: [
            {
              imgUrl: require("@/assets/img/solution/pageImg/5.jpg"),
              imgAlt: "1"
            },
          ]
        }
      }
    }

  }
</script>

<style scoped lang="scss">
@import "@/views/solution/unifyStyle";
</style>
